import React from 'react';
import Title from '../../title';
import Loading from '../../loading';
import $ from "jquery";
import { Dropdown } from 'semantic-ui-react';
import View from './view';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class PurchaseRequest extends React.Component {

  state = {
    load: false,
    message: '', menuPermission: [],
    allbranch: [],
  }

  componentDidMount() {
    this.getBranchs();
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('purchase-request', this.props.menus);
    this.setState({ menuPermission })
  }

  getBranchs() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      let branchState;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
        branchState = data[i].state;
      }
      this.setState({ selectedBranch: branchId })
    }
  }

  render() {
    let { load, message, branchOptions, selectedBranch } = this.state;
    return (
      <div>
        <Title title={'Purchase Request'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view  ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <center style={{color: 'red'}}><b>{this.state.permissionError}</b></center>
                { selectedBranch ?
                  (
                    <div>
                      <View branch={selectedBranch} temprequest={this.state.temprequest}
                          menuPermission={this.state.menuPermission}
                          addrequest={this.state.addrequest} pendingrequestview={this.state.pendingrequestview}
                          pendingrequestedit={this.state.pendingrequestedit}
                          purchasefrombranch={this.state.purchasefrombranch}
                          purchasefrompurchaser={this.state.purchasefrompurchaser}
                          />
                    </div>
                  ) :
                  (
                    <div></div>
                  )
                }
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }

      </div>
    );
  }
}

export default PurchaseRequest;
